import React, { useState, useMemo, useCallback } from "react";
import FormDataContext from "./FormDataContext";
const FormDataProvider = ({ initialFormData = {}, children = void 0 }) => {
  const [formData, updateState] = useState(initialFormData);
  const setFormData = useCallback(
    (id, fieldData) => {
      updateState({
        ...formData,
        [id]: {
          ...formData[id],
          ...fieldData,
          dirty: true
        }
      });
    },
    [formData]
  );
  const clearField = useCallback(
    (id) => {
      if (Object.keys(formData).find((field) => field === id)) {
        delete formData[id];
        updateState(formData);
      }
    },
    [formData]
  );
  const contextValue = useMemo(
    () => ({
      formData,
      setFormData,
      clearField
    }),
    [clearField, formData, setFormData]
  );
  return /* @__PURE__ */ React.createElement(FormDataContext.Provider, { value: contextValue }, children);
};
export default FormDataProvider;
